export default __webpack_public_path__ + "85916c9678c3ddfdfd8b35ef1800b6de.svg";